module.exports = __webpack_public_path__ + "static/media/IconIot.96280a51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/IconIot.png
// module id = 466
// module chunks = 0